import { assertEvent, assign, type ActionArgs } from 'xstate';

import { PaymentStatePollingContext } from './payment-state-polling-machine.context';
import { PaymentStatePollingEvent } from './payment-state-polling-machine.events';

// ─────────────────────────────────────────────────────────────────────────────

const onStartPolling: PaymentStatePollingMachineAction = assign({
  orderId({ event }) {
    assertEvent(event, 'START');
    return event.params.orderId;
  },
});

const onCreatePayment: PaymentStatePollingMachineAction = assign({
  paymentState({ event }) {
    assertEvent(event, 'CREATE_PAYMENT');
    return event.params;
  },
});

const onPaymentStateFetched: PaymentStatePollingMachineAction = assign({
  paymentState({ event }) {
    assertEvent(event, 'xstate.done.actor.fetchPaymentState');
    return event.output;
  },
});

const clearPaymentState: PaymentStatePollingMachineAction = assign({
  paymentState: undefined,
});

// ─── External Actions ────────────────────────────────────────────────────────

const onPaymentCanceled: PaymentStatePollingMachineAction = () => {};
const onPaymentFulfilled: PaymentStatePollingMachineAction = () => {};
const onPaymentStateError: PaymentStatePollingMachineAction = () => {};
const clearPendingPayment: PaymentStatePollingMachineAction = () => {};
const incrementPurchaseAttempt: PaymentStatePollingMachineAction = () => {};

// ─────────────────────────────────────────────────────────────────────────────

export const PaymentStatePollingActions = {
  onStartPolling,
  onCreatePayment,
  onPaymentCanceled,
  onPaymentFulfilled,
  onPaymentStateFetched,
  onPaymentStateError,
  clearPaymentState,
  clearPendingPayment,
  incrementPurchaseAttempt,
};

export type PaymentStatePollingMachineAction<
  ActionParams extends Record<string, unknown> | void = void,
> = (
  actionArgs: ActionArgs<
    PaymentStatePollingContext,
    PaymentStatePollingEvent,
    PaymentStatePollingEvent
  >,
  params: ActionParams,
) => void;
